/*!
 * © 2024. The EGT Universe. All Rights Reserved.
 * License: Requires ACTIVE AppArtisan Subscription.
 * For more information visit: https://egtuniverse.com/legal
 *
 * Created for Universe App Tools.
 *
 * Created by Justin K Kazmierczak.
 */
var _ = require("../../../uam/module.js")(module.exports, {
    namespace: "email.greeting",
    title: "Email Greeting",
    description: "Greeting row — \"Hi, [name],\" — displayed as an H2 in platform emails.",
    supportServer: true,
    control: false,
    foruseIn: ["email"],
    fields: {
        "name": {
            title: "Name",
            type: "string",
            description: "The recipient's name or email address.",
            required: false,
            default: "there"
        }
    }
});
var $ = require("../../../uam/scafolding.js");

exports.render = async function (options) {
    var { html } = await exports.renderEmail(options);
    return [{
        n: "ua.element.serverNotSupported",
        inner: {
            n: "json",
            type: "ua/interface",
            by: "email.greeting",
            i: JSON.stringify({
                n: "html",
                html: `<div style="max-width:480px;margin:0 auto;font-family:Arial,Helvetica,sans-serif;">${html}</div>`
            })
        }
    }];
};

exports.renderEmail = async function (options) {
    var name = (options && options.name) ? options.name : "there";
    var cfg = $.config || {};
    var primary = (cfg.my && cfg.my.app && cfg.my.app.colors && cfg.my.app.colors.primary) || "#6C757D";

    var html = `<tr>
  <td style="padding:20px 20px 10px 20px;font-family:Arial,Helvetica,sans-serif;">
    <h2 style="margin:0;padding:0;font-size:22px;font-weight:bold;color:${primary};">
      Hi, ${name},
    </h2>
  </td>
</tr>`;

    var text = `Hi, ${name},`;

    return { html, text };
};
